module.exports = __webpack_public_path__ + "img/phone.7350293d.svg";